var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 5.5,
    stroke: "#060606",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 36.5833L17.75 28.125L14.125 36.5833H21.375Z",
    stroke: "#212121",
    strokeOpacity: 0.8,
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.482 26.1145C34.0443 27.6768 34.8261 28.4586 34.64 29.6645C34.6284 29.7342 34.6147 29.8035 34.599 29.8724C34.309 31.0565 33.5115 31.3876 31.9213 32.0474C29.7289 32.956 27.3163 33.1939 24.9887 32.7311C22.661 32.2682 20.523 31.1254 18.845 29.4471C17.1671 27.7689 16.0245 25.6307 15.562 23.303C15.0996 20.9753 15.3378 18.5627 16.2468 16.3705C16.9053 14.7791 17.2352 13.984 18.4218 13.6928C18.4762 13.6807 18.5728 13.6602 18.6272 13.6517C19.8355 13.4668 20.6161 14.2474 22.1785 15.8098L32.482 26.1145Z",
    stroke: "#212121",
    strokeOpacity: 0.8,
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4596 17.2513C34.7943 17.2513 35.8763 16.1693 35.8763 14.8346C35.8763 13.4999 34.7943 12.418 33.4596 12.418C32.1249 12.418 31.043 13.4999 31.043 14.8346C31.043 16.1693 32.1249 17.2513 33.4596 17.2513Z",
    stroke: "#212121",
    strokeOpacity: 0.8,
    strokeWidth: 1.8125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6055 18.6218L31.9045 16.6836L29.686 22.7253",
    stroke: "#212121",
    strokeOpacity: 0.8,
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.93f86cf6f1cbbe6598c01d1ff0df487f.svg";
export { ForwardRef as ReactComponent };